/**
 * Base class for defining a strategy.
 * All strategies must extend this class and implement the `execute` and `isValid` methods.
 */
export class BaseStrategy {
  /**
   * Executes the strategy with given parameters.
   * This method must be implemented by subclasses.
   *
   * @param {any} params - Parameters required to execute the strategy.
   * @throws {Error} If the method is not implemented in a subclass.
   * @returns {any}
   */
  // eslint-disable-next-line no-unused-vars
  execute(params) {
    throw new Error('This method should be implemented by subclasses')
  }

  /**
   * Checks if the strategy is valid.
   * This method must be implemented by subclasses.
   *
   * @abstract
   * @param {any} params - Parameters required to execute the strategy.
   * @returns {boolean} Indicates if the strategy is valid.
   * @throws {Error} If the method is not implemented in a subclass.
   */
  // eslint-disable-next-line no-unused-vars
  static isValid(params) {
    throw new Error('This method should be implemented by subclasses')
  }
}
